import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64a5e6f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-content-around align-items-center flex-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex align-items-center font-bold" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "顧客詳細")
], -1))
const _hoisted_3 = { class: "flex align-items-right w-2.5rem h-2.5rem font-bold border-round btn-wrapper" }

import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";
import Profile from "./Profile.vue";
import BookingHistory from "./BookingHistory.vue";
import SpecialNote from "./SpecialNote.vue";
import { ref } from "vue";
import { AccountServices } from "@/clinic/services";
import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import type { ICustomer, ITag } from "@/clinic/typings";
import CustomerTagView from "@/clinic/views/common/customer/tag/index.vue";
import { get, templateRef } from "@vueuse/core";
import DialogMergeHotpepper from "@/clinic/views/Customer/components/List/DialogMergeHotpepper.vue";
import { useStore } from "vuex";
import { ClinicPartner } from "@/clinic/typings/enums/clinic";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    clinicId: null,
    customerId: null,
    accountId: null,
    linkCustomer: { type: Boolean },
    customer: null,
    tags: null
  },
  emits: ["refreshCustomer"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  clinicId: number;
  customerId: number;
  accountId: number;
  linkCustomer: boolean;
  customer: ICustomer;
  tags: ITag[];
};

const toast = useToast();
const store = useStore();

const loading = ref(false);



const dialogMergeHotpepper = templateRef<HTMLElement | null>("dialogMergeHotpepper", null);

const showDialog = async () => {
  get(dialogMergeHotpepper)?.showDialog();
  get(dialogMergeHotpepper)?.setCustomerId(props.customerId);
  await get(dialogMergeHotpepper)?.fetchHotpepperCustomer();
};

const goToEdit = (id: number) => {
  RouterUtils.goToWithParams(RouterConstants.CUSTOMER_EDIT_ROUTER_NAME, {
    id: id,
  });
};

const successCallback = () => {
  loading.value = false;
  document.getElementById("direct-messages-right-sidebar").getElementsByClassName("p-sidebar-close")[0].click();
};

const errorCallback = () => {
  loading.value = false;
  toast.add({
    severity: "error",
    detail: "何かが間違っています。後でもう一度試してください",
    life: 3000,
  });
};

const linkToCustomer = async (cusId: number, accId: number) => {
  loading.value = true;
  await AccountServices.linkToCustomer(cusId, accId, successCallback, errorCallback);
};

const onRefreshCustomer = () => emits("refreshCustomer");

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (!props.linkCustomer)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: "ホットペッパー顧客と統合",
              class: "btn-merge-hotpepper mr-2",
              onClick: showDialog
            }))
          : _createCommentVNode("", true),
        (!props.linkCustomer && _unref(store).getters['authClient/selectedClinic'].partner == _unref(ClinicPartner).Unaffiliated)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              label: "編集",
              class: "p-button-outlined mr-2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (goToEdit(props.customerId)))
            }))
          : _createCommentVNode("", true),
        (props.linkCustomer)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              label: "顧客情報を紐付け",
              class: "p-button-outlined",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (linkToCustomer(props.customerId, props.accountId)))
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_unref(TabView), { class: "customer-detail" }, {
      default: _withCtx(() => [
        _createVNode(_unref(TabPanel), { header: "顧客データ情報" }, {
          default: _withCtx(() => [
            _createVNode(Profile, {
              customer: props.customer,
              "list-tags": props?.tags,
              tags: props?.customer?.tags,
              comment: props?.customer.comment,
              "clinic-id": props?.clinicId
            }, null, 8, ["customer", "list-tags", "tags", "comment", "clinic-id"])
          ]),
          _: 1
        }),
        _createVNode(_unref(TabPanel), { header: "顧客タグ" }, {
          default: _withCtx(() => [
            _createVNode(CustomerTagView, {
              customerId: props.customer?.id,
              automatic_tags: __props.customer?.automatic_tags || [],
              tags: __props.customer?.tags || [],
              onRefreshCustomer: onRefreshCustomer
            }, null, 8, ["customerId", "automatic_tags", "tags"])
          ]),
          _: 1
        }),
        _createVNode(_unref(TabPanel), { header: "予約履歴" }, {
          default: _withCtx(() => [
            _createVNode(BookingHistory, {
              bookings: props?.customer?.bookings,
              "customer-id": props.customerId
            }, null, 8, ["bookings", "customer-id"])
          ]),
          _: 1
        }),
        _createVNode(_unref(TabPanel), { header: "特記事項" }, {
          default: _withCtx(() => [
            _createVNode(SpecialNote, {
              customer: props.customer
            }, null, 8, ["customer"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(DialogMergeHotpepper, {
      ref_key: "dialogMergeHotpepper",
      ref: dialogMergeHotpepper
    }, null, 512),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})